<ng-container *transloco="let t">
  <app-search-filter-box (searchValue)="valuesFilter = $event"></app-search-filter-box>
  <span *ngIf="mobile" class="fixed-space-16" aria-hidden="true"></span>
  <popsy-checkbox
    [text]="t('label_all')"
    [mobileMode]="mobile"
    [checked]="getIsColorSelected('label_all')"
    (valueChange)="onCheckboxChecked($event, 'label_all')"></popsy-checkbox>
  <ng-container
    *ngFor="let color of phoneColors$ | async; let pos = index; trackBy: trackByColor">
    <popsy-checkbox
      [text]="color | translateColor"
      [mobileMode]="mobile"
      [checked]="getIsColorSelected(color)"
      (valueChange)="onCheckboxChecked($event, color)"></popsy-checkbox>
  </ng-container>
</ng-container>
